import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import DashboardLayout from "./layout/dashboard/dashboardLayout";
import MainDashboard from "./pages/Dashboard/MainDashboard";
import LogoLayout from "./layout/LogoOnlyLayout/logoLayout";
import LoginSection from "./pages/Login/LoginSection";
import Language from "./pages/Languages/Language";
import Users from "./pages/Users/Users";
import Books from "./pages/Books/Books";
import Chapter from "./pages/Chapters/Chapter";
import ChapterContent from "./pages/ChapterContent/ChapterContent";
import Announcements from "./pages/Announcements/Announcements";
import HomeSection from "./pages/Home/HomeSection";

export default function RoutesSection() {
  const Authentication = () => {
    if (localStorage.getItem("admin_token")) {
      return <Navigate to={"/dashboard"}></Navigate>;
    } else {
      return <Navigate to={"/"}></Navigate>;
    }
  };
  return (
    <>
      <Routes>
        <Route element={<DashboardLayout />}>
          {/* <Route path="/" element={<Authentication />} /> */}
          <Route path="/dashboard" element={<MainDashboard />} />
          <Route path="/users" element={<Users />} />
          <Route path="/languages" element={<Language />} />
          <Route path="/books" element={<Books />} />
          <Route path="/chapters" element={<Chapter />} />
          <Route path="/contents" element={<ChapterContent />} />
          <Route path="/announcements" element={<Announcements />} />
        </Route>
        <Route>
          <Route element={<LogoLayout />}>
            <Route path="/" element={<HomeSection />} />
            <Route path="/login" element={<LoginSection />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
}
